export default __webpack_public_path__ + "static/media/team-member-19.69f2faa0.jpg";